import React from 'react';
import { Typography, Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Dropzone from 'react-dropzone';
import Alert from '@material-ui/lab/Alert';
import CropIcon from '@material-ui/icons/Crop';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import './style.css';
import WallpaperIcon from '@material-ui/icons/Wallpaper';
// ======================================================================

export const SelectImage = ({ setOpen, id, image, setImage }) => {
  const acceptFile = (file) => {
    const fileTypes = ['image/jpg', 'image/jpeg', 'image/png'];
    if (file.length > 0 && fileTypes.includes(file[0].type)) {
      setImage({ ...image, temp: URL.createObjectURL(file[0]) });
      setOpen(true);
    }
  };

  const UploadBox = () => {
    return (
      <label htmlFor='meeting_image' display='block' name='uploadImage'>
        <Box boxShadow={3} className='uploadBoxContainer'>
          <input
            type='file'
            accept='image/*'
            hidden
            id='meeting_image'
            onChange={(e) => acceptFile(e.target.files)}
            name='image'
            required
          />
          <Dropzone
            onDrop={(file) => acceptFile(file)}
            multiple={false}
            style={{
              width: '100%',
              height: '100%',
            }}
            onClick={() => {
              setOpen(true);
            }}
            id='teestt'
          >
            {({ getRootProps }) => (
              <Box className='uploadBox' {...getRootProps()}>
                <WallpaperIcon className='uploadImageBox' fontSize="large" />
                <Typography variant='body1' color='primary'>
                  Drag & drop or click to add image
                </Typography>
                <Typography variant='caption' color='textSecondary'>
                  JPEG or PNG
                </Typography>
              </Box>
            )}
          </Dropzone>
        </Box>
      </label>
    );
  };

  const MeetingImage = () => {
    return (
      <Box boxShadow={3} className='uploadBoxContainer'>
        <img
          src={image.value}
          alt='upload meeting'
          className='image'
          id='meeting-image'
        />
        <div className='overlay'>
          {image.temp && (
            <IconButton
              className='meeting-image-icon'
              name='crop-image'
              id='crop-image'
              color='primary'
              onClick={() => {
                setOpen(true);
              }}
            >
              <CropIcon color='primary' />
            </IconButton>
          )}
          <IconButton
            className='meeting-image-icon'
            name='delete-image'
            id='delete-image'
            color='primary'
            onClick={() => {
              setImage({
                ...image,
                value: null,
                blob: null,
                temp: null,
              });
              !id && localStorage.removeItem('meetingImageUrl');
              !id && localStorage.removeItem('meetingImageBlob');
            }}
          >
            <DeleteForeverIcon color='primary' />
          </IconButton>
        </div>
      </Box>
    );
  };

  return (
    <div>
      {image.error && (
        <Alert severity='error' id='meeting-image-error'>
          {image.error}
        </Alert>
      )}
      {image.value ? <MeetingImage /> : <UploadBox />}
    </div>
  );
};
